import appPackage from '../../package.json'
const API_URL = window.location.origin + '/api'

/**
 * 根据平台获取对应的页面路径
 * @param platform 平台类型
 * @returns 对应的页面路径
 */
const getPlatformPage = (platform?: string): string => {
	const selectedPlatform = platform || localStorage.getItem('selectedPlatform')
	switch (selectedPlatform) {
		case 'operation':
			return '/screen'
		case 'lifecycle':
			return '/screen2'
		case 'project':
			return '/maku/biz_deployment/index'
		default:
			return '/screen' // 默认运维平台
	}
}

/**
 * 常量
 */
export default {
	// 版本号
	version: appPackage.version,
	// 登录成功后，跳转页面
	// loginPage: '/dashboard/index',
	loginPage: '/screen',
	// 根据平台获取页面路径
	getPlatformPage,
	// API地址
	apiUrl: API_URL,
	// 第三方登录地址
	thirdLoginUrl: API_URL + '/sys/third/render/',
	// 文件上传地址
	uploadUrl: API_URL + '/sys/file/upload',
	// online 文件上传地址
	onlineUploadUrl: API_URL + '/sys/file/uploads',
	// 文件预览地址
	previewUrl: window.location.origin + '/preview/onlinePreview',
	// 环境变量
	env: {
		MODE: import.meta.env.MODE,
		PROD: import.meta.env.PROD,
		DEV: import.meta.env.DEV,
		SSR: import.meta.env.SSR
	}
}
